export const CertificateDocumentsVendorInfo:any = {
  productAssociationList: [
    {
      id: "1",
      productAssociation: "PRODUCT ASSOCIATION 1"
    },
    {
      id: "2",
      productAssociation: "PRODUCT ASSOCIATION 2"
    },
    {
      id: "3",
      productAssociation: "PRODUCT ASSOCIATION 3"
    }
  ],
  vendorRoleList: [
    {
      id: "4",
      vendorRole: "VENDOR ROLE 1"
    },
    {
      id: "5",
      vendorRole: "VENDOR ROLE 2"
    },
    {
      id: "6",
      vendorRole: "VENDOR ROLE 3"
    }
  ],
  vendorGroupList: [
    {
      id: "7",
      vendorGroup: "VENDOR GROUP 1"
    },
    {
      id: "8",
      vendorGroup: "VENDOR GROUP 2"
    },
    {
      id: "9",
      vendorGroup: "VENDOR GROUP 3"
    }
  ]
}
